import { render, staticRenderFns } from "./CompleteDeleteAccount.vue?vue&type=template&id=ee38863e"
import script from "./CompleteDeleteAccount.vue?vue&type=script&lang=js"
export * from "./CompleteDeleteAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports